module.exports = __webpack_public_path__ + "img/confirm_session_complete.30d7a6b1.png";